/**
 * @generated SignedSource<<a573ee8c3e5002f002e4b259518979ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TrackAssetVideoProgressInput = {
  assetUsageId: string;
  contentId: string;
  contentUsageId?: string | null;
  percent: number;
  seconds: number;
};
export type useTrackAssetVideoProgressMutation$variables = {
  input: TrackAssetVideoProgressInput;
};
export type useTrackAssetVideoProgressMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type useTrackAssetVideoProgressMutation = {
  response: useTrackAssetVideoProgressMutation$data;
  variables: useTrackAssetVideoProgressMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TrackAssetVideoProgressResponse",
    "kind": "LinkedField",
    "name": "trackAssetVideoProgress",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTrackAssetVideoProgressMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTrackAssetVideoProgressMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "710c42f0821dccda642b951b1a7ae80d",
    "id": null,
    "metadata": {},
    "name": "useTrackAssetVideoProgressMutation",
    "operationKind": "mutation",
    "text": "mutation useTrackAssetVideoProgressMutation(\n  $input: TrackAssetVideoProgressInput!\n) {\n  response: trackAssetVideoProgress(input: $input) {\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c50c0d462679cf9e6fef7e6d9918c00d";

export default node;
